import { BPx1e3_DECIMALS, FundWithDetailsEntity } from '@/src/lib/MayzSmartDB';
import { useTokensStore } from '@/src/store/global';
import { formatPercentage } from '@/src/lib/SmartDB/Commons/formatters';
import { showToken_Amount_NotRounded } from '@/src/store/global/tokensStoreModelHelpers';
import styles from './Commission.module.scss';

interface CommissionProps {
    isDeposit: boolean;
    fund: FundWithDetailsEntity;
    commission_FT: bigint;
    real_FT: bigint;
    classNameStyle?: string;
}

export default function Commission(props: CommissionProps) {
    //-----------------
    const { fund, isDeposit, commission_FT, real_FT, classNameStyle } = props;
    //-----------------
    const tokensStore = useTokensStore();
    //-----------------
    return (

        
        <section className={`${styles.conversionSection} ${classNameStyle !== undefined ? styles[classNameStyle] : styles.dark}`}>
            <div className={styles.conversionItem}>
                <p className={styles.text}>Annual Fee</p>
                <p className={styles.value}>{formatPercentage(fund.fdCommission_PerYear_InBPx1e3, 2, false, BPx1e3_DECIMALS)}</p>
            </div>
            {isDeposit ? (
                <>
                    <div className={styles.conversionItem}>
                        <p className={styles.text}>{isDeposit ? `Tokens to Mint` : `Tokens to Redeem`}</p>
                        <p className={styles.value}>{showToken_Amount_NotRounded(tokensStore, real_FT, fund.getNET_id_CS(), fund.fdFundFT_TN_Hex)}</p>
                    </div>
                    <div className={styles.conversionItem}>
                        <p className={styles.text}>{isDeposit ? `Commission to pay` : `Commission to get back`}</p>
                        <p className={styles.value}>{showToken_Amount_NotRounded(tokensStore, commission_FT, fund.getNET_id_CS(), fund.fdFundFT_TN_Hex)}</p>
                    </div>
                </>
            ) : (
                <>
                    <div className={styles.conversionItem}>
                        <p className={styles.text}>{isDeposit ? `Commission to pay` : `Commission to get back`}</p>
                        <p className={styles.value}>{showToken_Amount_NotRounded(tokensStore, commission_FT, fund.getNET_id_CS(), fund.fdFundFT_TN_Hex)}</p>
                    </div>
                    <div className={styles.conversionItem}>
                        <p className={styles.text}>{isDeposit ? `Tokens to Mint` : `Tokens to Burn`}</p>
                        <p className={styles.value}>{showToken_Amount_NotRounded(tokensStore, real_FT, fund.getNET_id_CS(), fund.fdFundFT_TN_Hex)}</p>
                    </div>
                </>
            )}
        </section>
    );
}
